import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MessageService } from 'src/app/service/common/message.service';
import { SupportService } from 'src/app/service/common/support.service';

@Component({
  selector: 'app-automation',
  templateUrl: './automation.component.html',
  styleUrls: ['./automation.component.css']
})
export class AutomationComponent implements OnInit {

  private _subs : Subscription = new Subscription();
  company : any;

  constructor(
    private supportService : SupportService,
    private msg : MessageService,
  ) { }

  ngOnInit(): void {
    this._subs.add(
      this.supportService.getCompanyDetails().subscribe(res => {
        this.company = res.data;
      })
    )
  }

  setValue(name, e){
    for (let key in this.company) {
      if(name === key){
        let value ;
        if(e.checked){
          value = "1";
        }else{
          value = "0";
        }
        this.company[key] = value;
      }
    }
  }

  updateAutomation(){
    this._subs.add(
      this.supportService.updateCompanyDetails(this.company).subscribe(res => {
        console.log(res);
        if(res.status == 'ok'){
          this.msg.success(res.message);
        }else{
          this.msg.error(res.message);
        }
      })
    )
  }

}
